import React, { ComponentPropsWithoutRef, FC } from 'react';

import { useTheme } from '@mui/material';

import { Svg } from '~/assets/icons/styles';
import { OneColorProps } from '~/assets/icons/types';

interface ThumbDownIconProps extends OneColorProps, ComponentPropsWithoutRef<'svg'> {
  filled?: boolean;
}

const ThumbDownIcon: FC<ThumbDownIconProps> = ({ color, filled, ...props }) => {
  const theme = useTheme();
  const iconColor = color || theme.palette.common.white;

  return (
    <Svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      svgColor={iconColor}
    >
      <path
        d="M15.4492 4.80576C15.0971 4.45361 14.674 4.27754 14.1799 4.27754H6.99325C6.64889 4.27754 6.31951 4.38235 6.00509 4.59196C5.69067 4.80157 5.46609 5.0561 5.33134 5.35554L2.63635 11.6888C2.59203 11.7936 2.5585 11.9059 2.53574 12.0256C2.51298 12.1454 2.5016 12.2577 2.5016 12.3625V14.1592C2.5016 14.6383 2.68127 15.0575 3.0406 15.4168C3.39993 15.7762 3.81915 15.9558 4.29826 15.9558H9.19416L8.18354 20.0882C8.10808 20.3726 8.13413 20.6496 8.2617 20.9191C8.38926 21.1886 8.59528 21.3982 8.87975 21.5479C9.16362 21.6977 9.45917 21.7501 9.7664 21.7052C10.0736 21.6602 10.3395 21.533 10.5641 21.3234L15.4376 16.4724C15.6017 16.3071 15.7325 16.116 15.8301 15.8992C15.9278 15.6824 15.9766 15.4543 15.9766 15.2147V6.0742C15.9772 5.58072 15.8014 5.15791 15.4492 4.80576Z"
        stroke="currentColor"
        strokeWidth="2"
        fill={filled ? 'currentColor' : undefined}
      />
      <rect
        x="23"
        y="15.8398"
        width="3.97932"
        height="11.5625"
        rx="1"
        transform="rotate(180 23 15.8398)"
        stroke="currentColor"
        strokeWidth="2"
        fill={filled ? 'currentColor' : undefined}
      />
    </Svg>
  );
};

export default ThumbDownIcon;
